import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS } from "@/data/content";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
  const c = useContent();
  const CONTACT = c.contact;
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/[0.07] bg-ink/60 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24 md:pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16">
          <div className="lg:col-span-5">
            <img src="/images/logo-full-bronze.png" alt="Sai Leela Decor — A Rajmata Jijau Enterprises Firm" className="h-36 w-auto" data-testid="footer-logo" />
            <p className="mt-6 text-sm text-stone2 leading-relaxed max-w-sm font-light">
              A trusted construction and space-development company — civil engineering,
              renovation, waterproofing, electrical, plumbing and interior work, delivered
              with precision across Badlapur, Thane and Mumbai.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-bronze mb-6">Explore</p>
            <ul className="space-y-3">
              {NAV_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-${label.toLowerCase()}-link`}
                    className="link-underline text-sm text-bone/70 hover:text-bone transition-colors duration-500"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-bronze mb-6">Studio</p>
            <ul className="space-y-3 text-sm text-bone/70 font-light">
              <li data-testid="footer-email">{CONTACT.email}</li>
              <li data-testid="footer-phone">{CONTACT.phone}</li>
              <li>{CONTACT.address}</li>
              <li className="pt-2 text-muted2">{CONTACT.cities.join(" · ")}</li>
            </ul>
            <Link
              to="/contact"
              data-testid="footer-cta-link"
              className="mt-8 inline-flex items-center gap-2 border border-bronze/40 text-bronze text-[11px] uppercase tracking-[0.25em] px-6 py-3 transition-all duration-500 hover:bg-bronze hover:text-obsidian"
            >
              Get in touch with us <ArrowUpRight size={13} />
            </Link>
          </div>
        </div>
        <div className="border-t border-white/[0.07] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted2 tracking-wider">© 2026 Sai Leela Decor · Style Your Space</p>
          <div className="flex items-center gap-6 text-xs text-muted2 tracking-wider">
            <a href={c.socials.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="hover:text-bone transition-colors duration-500">Instagram</a>
            <a href={c.socials.pinterest} target="_blank" rel="noreferrer" data-testid="footer-pinterest-link" className="hover:text-bone transition-colors duration-500">Pinterest</a>
            <a href={c.socials.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin-link" className="hover:text-bone transition-colors duration-500">LinkedIn</a>
            <a href={c.socials.whatsapp} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="hover:text-bronze transition-colors duration-500">WhatsApp</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
